import "./styles.scss"
import { observer } from 'mobx-react';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict.tsx';
import { IUnitValue } from 'shared/models';
import { formatValueWithUnits } from 'pages/profile-dashboard/utilities/formatValueWithUnits.ts';
import classnames from 'classnames';

type Props = {
    labels: string[];
    values: IUnitValue[];
    colors: string[];
    onHover: (index: number) => void;
    onLeave: () => void;
    className?: string;
};

export const PPDWidgetPieChartLegend = observer(({
    labels, values, colors, onHover, onLeave, className
}: Props) => {
    const { units } = useDashboardDict();

    return (
        <div className={classnames("ppd-widget-pie-chart-legend", className)}>
            <ul className="ppd-widget-pie-chart-legend__list">
                {labels.map((label, i) => (
                    <li
                        key={label}
                        className="ppd-widget-pie-chart-legend__item"
                        onMouseEnter={() => onHover(i)}
                        onMouseLeave={onLeave}
                    >
                        <div className="ppd-widget-pie-chart-legend__label">
                            <span
                                className="ppd-widget-pie-chart-legend__color"
                                style={{
                                    backgroundColor: colors[i],
                                }}
                            />
                            {label}
                        </div>
                        <span className="ppd-widget-pie-chart-legend__value"> {formatValueWithUnits(values[i], units)} </span>
                    </li>
                ))}
            </ul>
        </div>
    )
});
